import { render, staticRenderFns } from "./hrPurchase.vue?vue&type=template&id=206cf339&scoped=true"
import script from "./hrPurchase.vue?vue&type=script&lang=js"
export * from "./hrPurchase.vue?vue&type=script&lang=js"
import style0 from "./hrPurchase.vue?vue&type=style&index=0&id=206cf339&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206cf339",
  null
  
)

export default component.exports